/* CRO dead-click reference fix - 2026-07-02 - DRAFT THEME ONLY.
   P0-1: ATC taps die silently (Clarity 58 dead / 0 rage = handler bound late,
   errored, or tap intercepted). This shim guarantees no tap is ever lost:
   1) instant pressed feedback on tap (capture phase, binds immediately - this
      file loads WITHOUT defer);
   2) watchdog: if no /cart/add network activity follows within 900ms, fall
      back to native form submit. Double-add-safe: skips fallback if a cart
      call already fired; a native submit navigates, so nothing races after it.
   Live implementation is Yahav's - see ClickUp task. */
(function () {
  'use strict';
  var SEL = '.ecom-product-single__add-to-cart--submit';

  function cartCallFiredSince(t0) {
    try {
      return performance.getEntriesByType('resource').some(function (r) {
        return r.startTime >= t0 && /\/cart\/add/.test(r.name);
      });
    } catch (e) { return false; }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (!btn || btn.dataset.croFallbackDone) return;
    btn.classList.add('cro-atc-waiting');
    var t0 = performance.now();
    var form = btn.closest('form');
    setTimeout(function () {
      btn.classList.remove('cro-atc-waiting');
      if (cartCallFiredSince(t0)) {
        console.debug('[CRO-fix] app handler served the tap; no fallback');
        return;
      }
      if (form) {
        btn.dataset.croFallbackDone = '1';
        console.debug('[CRO-fix] dead tap detected -> native /cart/add fallback');
        if (typeof form.requestSubmit === 'function') { form.requestSubmit(btn); }
        else { form.submit(); }
      }
    }, 900);
  }, { capture: true, passive: true });
})();
